<template>
    <div class="form-group" :class="{scroll}">
        <label v-if="hasLabel" :class="labelClasses">
            {{ label }}
        </label>
        <el-select
            :popper-append-to-body="!scroll"
            :class="'select-' + color"
            size="large"
            :placeholder="placeholder"
            :filterable="filterable"
            :clearable="clearable"
            :multiple="multiple"
            :disabled="sortedOptions.length == 0 || disabled"
            v-model="castedValue">

            <el-option
                    v-for="option in sortedOptions" :key="option.key"
                    class="select-primary"
                    :value="option.key"
                    :label="option.label">

                <div v-if="notes">
                    <span style="float: left">{{ option.label }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ notes[option.key] }}</span>
                </div>

                <div v-if="templates" v-html="templates[option.key]">
                </div>

            </el-option>
        </el-select>
        <div v-if="error" class="invalid-feedback" style="display: block;">
            {{ error }}
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            value: {
                required: true
            },
            options: {
                type: Object,
                required: true
            },
            notes: {
                type: Object,
                default: null
            },
            templates: {
                type: Object,
                default: null
            },
            color: {
                type: String,
                default: 'primary'
            },
            label: {
                type: String,
                default: null
            },
            error: {
                type: String,
                default: null
            },
            placeholder: {
                type: String,
                default: null
            },
            filterable: {
                type: Boolean,
                default: false
            },
            sort: {
                type: Boolean,
                default: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: false
            },
            scroll: {
                type: Boolean,
                default: false
            },
            labelClasses: {
                type: String,
                default: ""
            },
        },

        data() {
            return {
                castedValue: null
            }
        },

        computed: {

            hasLabel() {
                return this.label !== null
            },

            sortedOptions() {
                let sorted = []
                for (let [key, label] of Object.entries(this.options)) {
                    sorted.push({ key, label })
                }
                if (this.sort) {
                    sorted.sort((a, b) => a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1)
                }
                return sorted
            }
        },

        created() {
            this.castValue(this.value)
        },

        watch: {

            value(newVal) {
                this.castValue(newVal)
            },
            
            castedValue(newVal) {
                this.$emit('input', newVal)
            }
        },

        methods: {

            castValue(value) {
                if (value === null) {
                    this.castedValue = this.multiple ? [] : null
                    return
                }
                if (this.multiple) {
                    // Don't cast multiple values.
                    this.castedValue = value
                    return
                }
                // Just in case the value is a number.
                this.castedValue = String(value)
            }
        }
    }
</script>

<style scoped>

    .form-group label {
        color: #525f7f;
        font-size: 0.875rem;
        font-weight: 600;
    }
    .form-group >>> .el-select.select-info .el-select__tags .el-tag {
        background: #5e72e4;
    }

</style>
